import { Card } from "primereact/card";
import { QuestionResponse } from "../models";
import moment from 'moment';

export default function DateResponseComponent({ response, format }: { response: QuestionResponse[], format: string }) {


    return (
        <Card>
            <div className="grid">
                {
                    response.map((response, index) => (
                        response?.fieldName && <>
                            <div key={index} className="col-6">
                                <span className='p-bold'>{response.fieldName} </span>
                            </div>

                            <div className='col-6'>
                                <span>{response.fieldValue ? moment(response.fieldValue).format(format ?? 'MM/DD/YYYY') : ''}</span>


                            </div>
                        </>
                    ))
                }
            </div>
        </Card >
    )
} 